// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"e7e51e80","569":"57a4d08f","851":"ab446db1","966":"ec8ffb18"}[chunkId] + ".chunk.js";
};